import React from 'react';

/**
 * Shared scaffolding for the custom project thumbnails: a white canvas with the
 * site's dark-mode base colour (#121110) as the only ink, a faint dotted paper
 * texture, and a 400x300 viewBox. Uses `meet` + a white element background so
 * the illustration is never cropped in the various card slots on the Projects
 * page — margins just render white. SMIL animations run because the cards live
 * inside `.op-page` / are otherwise exempt from the legacy motion kill-switch.
 */
export const INK = '#121110';

const Texture: React.FC = () => (
  <g fill={INK} opacity="0.05">
    {Array.from({ length: 6 }).map((_, r) =>
      Array.from({ length: 9 }).map((_, c) => (
        <circle key={`${r}-${c}`} cx={22 + c * 45} cy={26 + r * 48} r="1.4" />
      ))
    )}
  </g>
);

interface ThumbFrameProps {
  label: string;
  children: React.ReactNode;
}

export const ThumbFrame: React.FC<ThumbFrameProps> = ({ label, children }) => (
  <svg
    viewBox="0 0 400 300"
    className="op-thumb w-full h-full bg-white transition-transform duration-700 ease-out group-hover:scale-105"
    preserveAspectRatio="xMidYMid meet"
    role="img"
    aria-label={label}
  >
    <rect width="400" height="300" fill="#ffffff" />
    <Texture />
    {children}
  </svg>
);

export default ThumbFrame;
